import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHierarchy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.9999 5.99678C13.1047 5.99678 14.0003 5.10117 14.0003 3.99637C14.0003 2.89158 13.1047 1.99597 11.9999 1.99597C10.8951 1.99597 9.99951 2.89158 9.99951 3.99637C9.99951 5.10117 10.8951 5.99678 11.9999 5.99678Z",
			stroke: "currentColor",
			strokeWidth: 1.7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.9999 22C13.1047 22 14.0003 21.1044 14.0003 19.9996C14.0003 18.8948 13.1047 17.9992 11.9999 17.9992C10.8951 17.9992 9.99951 18.8948 9.99951 19.9996C9.99951 21.1044 10.8951 22 11.9999 22Z",
			stroke: "currentColor",
			strokeWidth: 1.7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.66495 22C5.76975 22 6.66536 21.1044 6.66536 19.9996C6.66536 18.8948 5.76975 17.9992 4.66495 17.9992C3.56016 17.9992 2.66455 18.8948 2.66455 19.9996C2.66455 21.1044 3.56016 22 4.66495 22Z",
			stroke: "currentColor",
			strokeWidth: 1.7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.3344 22C20.4392 22 21.3348 21.1044 21.3348 19.9996C21.3348 18.8948 20.4392 17.9992 19.3344 17.9992C18.2296 17.9992 17.334 18.8948 17.334 19.9996C17.334 21.1044 18.2296 22 19.3344 22Z",
			stroke: "currentColor",
			strokeWidth: 1.7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.66504 17.9992V17.9992C4.66504 15.0531 7.05333 12.6648 9.99945 12.6648H14.0003C15.415 12.6648 16.7719 13.2268 17.7722 14.2272C18.7726 15.2276 19.3347 16.5844 19.3347 17.9992V17.9992",
			stroke: "currentColor",
			strokeWidth: 1.7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 5.99677V17.9992",
			stroke: "currentColor",
			strokeWidth: 1.7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgHierarchy;
